const MastercardLogo = ({ width = 50, height = 32 }) => (
  <svg width={width} height={height} viewBox="0 0 130 80" xmlns="http://www.w3.org/2000/svg">
    {/* Círculo rojo */}
    <circle cx="45" cy="40" r="35" fill="#EB001B" />
    {/* Círculo naranja */}
    <circle cx="85" cy="40" r="35" fill="#F79E1B" />
    {/* Intersección - mezcla de colores */}
    <path
      d="M65 13.5C71.8 18.5 76.5 26 76.5 40C76.5 54 71.8 61.5 65 66.5C58.2 61.5 53.5 54 53.5 40C53.5 26 58.2 18.5 65 13.5Z"
      fill="#FF5F00"
    />
  </svg>
);
export default MastercardLogo;
